import { useI18n } from 'builder/hooks/useI18n'
import DrawerModal from 'builder/components/DrawerModal/DrawerModal'

import { MappedProgressData } from '../types'
import { ModalSection } from './ModalSection'

import * as Styles from './styles'

const TRANSLATIONS = 'builder.dashboard.progress_tracker.modal'

type MobileModalProps = {
  isOpen: boolean
  onClose: () => void
  progressData?: MappedProgressData
}

export const MobileModal = ({ progressData, onClose, isOpen }: MobileModalProps) => {
  const { i18n } = useI18n()

  return (
    <DrawerModal open={isOpen} onClose={onClose}>
      <Styles.ModalContainer>
        <Styles.MobileHandle />
        <Styles.ModalContent>
          <Styles.ModalHeader>
            <Styles.ModalTitle>{i18n.t(`${TRANSLATIONS}.title`)}</Styles.ModalTitle>
          </Styles.ModalHeader>
          <Styles.ModalBody>
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.resumes`)}
              services={progressData?.resumes}
            />
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.jobs`)}
              services={progressData?.jobs}
            />
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.interviews`)}
              services={progressData?.interview}
            />
            <ModalSection
              sectionTitle={i18n.t(`${TRANSLATIONS}.careers`)}
              services={progressData?.learning}
            />
          </Styles.ModalBody>
        </Styles.ModalContent>
      </Styles.ModalContainer>
    </DrawerModal>
  )
}
